import { RootState } from "../../app";
import { ICategorization } from "../../configMap/interfaces/category";
import { createSelector } from "@reduxjs/toolkit";
import { selectConfigMapCategorizations } from "../../configMap/selectors/categorizationLinkSelectors";

const EMPTY_ARRAY: Array<ICategorization> = [];

const selectConfigMapCategorizationsFromState = createSelector(
  [(state: RootState) => state.configMapReducer.configMap],
  (configMap) => {
    if (!configMap) {
      return EMPTY_ARRAY;
    }

    const categorizationsWithConfig = selectConfigMapCategorizations(configMap);

    return categorizationsWithConfig
      .map((cwc) => cwc.categorization)
      .sort(
        (item1, item2) =>
          (item1?.index ?? Number.MAX_VALUE) -
          (item2?.index ?? Number.MAX_VALUE),
      );
  },
);

export default selectConfigMapCategorizationsFromState;
